
import React from 'react';

const SummaryItem = ({ label, value }) => (
    <div className="bg-gray-50 p-3 rounded-lg flex justify-between items-center">
        <span className="text-sm font-medium text-gray-600">{label}</span>
        <span className="text-sm font-bold text-gray-900">{value || 'N/A'}</span>
    </div>
);

const Step5_Summary = ({ formData, prevStep, handleSubmit }) => {

  return (
    <div>
      <h2 className="text-2xl font-semibold text-gray-700 mb-6">Étape 5 : Résumé de votre projet</h2>
      <div className="space-y-6 bg-white p-6 rounded-xl border border-gray-200">

        <div>
            <h3 className="font-bold text-lg text-blue-700 mb-3">Véhicule</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                <SummaryItem label="Type" value={formData.vehicleType} />
                <SummaryItem label="Marque & Modèle" value={`${formData.vehicleBrand} ${formData.vehicleModel}`} />
                <SummaryItem label="Année" value={formData.vehicleYear} />
                <SummaryItem label="Capacité batterie" value={`${formData.batteryCapacity} kWh`} />
            </div>
        </div>

        <div>
            <h3 className="font-bold text-lg text-green-700 mb-3">Usage</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                <SummaryItem label="Distance/jour" value={`${formData.dailyMileage} km`} />
                <SummaryItem label="Lieu de stationnement" value={formData.parkingLocation} />
                <SummaryItem label="Type d'installation" value={formData.installationType} />
                <SummaryItem label="Puissance souhaitée" value={formData.desiredPower} />
            </div>
        </div>

        <div>
            <h3 className="font-bold text-lg text-yellow-700 mb-3">Installation</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                <SummaryItem label="Distance tableau-borne" value={`${formData.distanceToPanel} m`} />
                <SummaryItem label="Type de compteur" value={formData.meterType} />
                <SummaryItem label="Puissance compteur" value={`${formData.meterPower} kVA`} />
                <SummaryItem label="Travaux de voirie" value={formData.roadworkNeeded} />
            </div>
        </div>

        <div>
            <h3 className="font-bold text-lg text-gray-700 mb-3">Contact</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                <SummaryItem label="Nom" value={formData.name} />
                <SummaryItem label="Email" value={formData.email} />
                <SummaryItem label="Téléphone" value={formData.phone} />
                <SummaryItem label="Code Postal" value={formData.postalCode} />
            </div>
        </div>

      </div>

      <div className="mt-8 flex justify-between">
        <button type="button" onClick={prevStep} className="px-8 py-3 bg-gray-200 text-gray-800 font-semibold rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 transition-colors">
          Précédent
        </button>
        <button type="submit" onClick={handleSubmit} className="px-8 py-3 bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors">
          Envoyer ma simulation
        </button>
      </div>
    </div>
  );
};

export default Step5_Summary;
